






























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3,logoutPanel,counter } from "@/components";
import { TbGoods, TbOrderPad,TbSettingsPad,TbGoodsSpecs, TbExChangeGoods } from '@/http';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import exchangeReminder from "./components/exchangeReminder.vue";
import {PrintEvent1,PrintEvent3} from "@/common/util/prints";
import {TbShop} from "@/http/api_TbShop"
import {TbShopReceiptTemplate} from "@/http/api_TbShopReceiptTemplate"
import JsBarcode from 'jsbarcode';
import { Toast } from 'vant';
const { userAgent } = navigator;
const isAndroid = userAgent.indexOf('Android') > -1 ||userAgent.indexOf('android') > -1 || userAgent.indexOf('Adr') > -1;; // android终端
@Component({
    components: {
        padHeadPanel3,logoutPanel,counter,exchangeReminder
    },
})
export default class changeOrderDetail extends Vue {
    public $refs: {
    };
    
    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=2; 

    id="";
    form:any={};
    list=[];

    /**左侧选中项-商品详情 */
    activeInfo:any={};
    /**左侧选中项-订单商品详情 */
    orderProductInfo:any={};

    /**需要调货数量 */
    num = 0;
    minNum=1;
    maxNum=null;

    fmoney=fmoney;

    /**规格 */
    specsSelectedList =[];

    userInfo:any={};

    /**系统配置 */
    settingContent:any={};
    /**是否允许负库存 */
    isZeroStock=null;
    /**库存 */
    totalStock = 0;

    /**已选中规格 */
    selectedList = [];
    selectedSpecName="";
    selectedSpecId="";
    /**历史选中规格 */
    historySelectedList = [];
    historySelectedSpecName="";
    historySelectedSpecId="";

    /**禁止取消选中 */
    noCancel = false;

    /**换货提醒弹窗 */
    exchangeShow = false;
    exchangeForm:any={};

    activeId="";

    isPrintLoading = false;


    /**支付方式 */
    get payName(){
        let str = "";
        if(this.form.paymentMethod){
            switch (this.form.paymentMethod) {
                case 1:
                    str="会员卡"
                    break;
                case 2:
                    str="现金"
                    break;
                case 3:
                    str="微信"
                    break;
                case 4:
                    str="支付宝"
                    break;
                case 5:
                    str="现金+会员卡+微信"
                    break;
                case 6:
                    str="现金+会员卡+支付宝"
                    break;
                case 7:
                    str="现金+微信"
                    break;
                case 8:
                    str="现金+支付宝"
                    break;
                case 9:
                    str="会员卡+微信"
                    break;
                case 10:
                    str="会员卡+支付宝"
                    break;
                case 11:
                    str="现金+会员卡"
                    break;
                case 13:
                    str="线下微信"
                    break;
                case 14:
                    str="线下支付宝"
                    break;
                case 15:
                    str="现金+线下支付宝"
                    break;
                case 16:
                    str="会员卡+线下支付宝"
                    break;
                case 17:
                    str="现金+线下微信"
                    break;
                case 18:
                    str="会员卡+线下微信"
                    break;
                case 19:
                    str="线下微信+线下支付宝"
                    break;
                case 20:
                    str="现金+会员卡+线下支付宝"
                    break;
                case 21:
                    str="现金+会员卡+线下微信"
                    break;
                case 22:
                    str="现金+线下支付宝+线下微信"
                    break;
                case 23:
                    str="会员卡+线下支付宝+线下微信"
                    break;
            
                default:
                    break;
            }
        }
        return str;
    }

    /**当前库存 */
    get nowStock(){
        let val = 0;
        val = calculate.subtraction(this.totalStock,this.num);
        return val;
    }

    created(){
        
    }
    async mounted(){
       this.id = this.$route.query.id; 
       this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
       await this.getSetting();
       await this.init();

    }


    async init(){
        let res = await TbOrderPad.GetOrderById({id:this.id});
        this.form = res;
        this.list = res.items;
    }

    async viewDetail(item){
        if(this.getProductStatus(item)=='isDisable') return;
        this.activeId = item.id;
        this.specsSelectedList = [];
        this.selectedList = [];
        this.historySelectedList = [];
        this.selectedSpecName = "";
        this.orderProductInfo = item;
        await this.getProductDetail(item);
        await this.setDefaultNum();
    }
    /**设置 需要调换数量 默认值*/ 
    async setDefaultNum(){
        let syNum = calculate.subtraction(this.orderProductInfo.num,this.orderProductInfo.returnedNum);
        let stock =  this.activeInfo.getGoodsItemsList.find(v=>v.id==this.orderProductInfo.goodsItemId).stock;
        this.totalStock = stock;
        if(this.isZeroStock){
            this.num = stock>0? Math.min(syNum,stock):syNum;
            this.maxNum = syNum;
        }else{
            if(stock){
                this.num = stock>0? Math.min(syNum,stock):syNum;
                this.maxNum = stock>0? Math.min(syNum,stock):0;
            }else{
                this.num=0;
                this.maxNum=0;
            }
        }
        
    }
    /**选完规格获取库存*/ 
    async getSpecStock(){
        let specName = "";
        let syNum = calculate.subtraction(this.orderProductInfo.num,this.orderProductInfo.returnedNum);
        let stock = 0;
        if(this.selectedList.length>0){
            if(this.selectedList.length==1){
                specName=this.selectedList[0].childList[0].name+'/-';
                if(this.activeInfo.getGoodsItemsList.some(v=>v.goodsSpecsName==specName)){
                    stock = this.activeInfo.getGoodsItemsList.find(v=>v.goodsSpecsName==specName).stock;
                }
            }else{
                let arr = this.activeInfo.goodsSpecsIds.split(",");
                this.selectedList = this.selectedList.map(v=>{
                    return{
                        ...v,
                        index:arr.findIndex(j=>j==v.id)
                    }
                })
                this.selectedList.sort((a,b)=>a.index-b.index);
                specName=this.selectedList[0].childList[0].name+'/'+this.selectedList[1].childList[0].name;
                if(this.activeInfo.getGoodsItemsList.some(v=>v.goodsSpecsName==specName)){
                    stock = this.activeInfo.getGoodsItemsList.find(v=>v.goodsSpecsName==specName).stock;;
                }
            }
            this.$nextTick(()=>{
                this.totalStock = stock;
                this.selectedSpecName= specName;
                this.selectedSpecId = this.activeInfo.getGoodsItemsList.findIndex(v=>v.goodsSpecsName==specName)>-1?this.activeInfo.getGoodsItemsList.find(v=>v.goodsSpecsName==specName).id:"";
                if(this.isZeroStock){
                    this.num = stock>0? Math.min(syNum,1):1;
                    this.maxNum = syNum;
                }else{
                    if(stock){
                        this.num = stock>0? Math.min(syNum,1):1;
                        this.maxNum = stock>0? Math.min(syNum,stock):0;
                    }else{
                        this.num=0;
                        this.maxNum=0;
                    }
                
                }
            })
        }else{
            this.setDefaultNum();
        }
        
    }
    /**获取商品详情 */
    async getProductDetail(item){
        let res = await TbGoods.GetTbGoodsById({
            id:item.goodId
        });
        this.activeInfo = res;
        if(res.goodsSpecsIds){
            await this.getInitGGListU(res.goodsSpecsIds);
            let goodsSpecsList= res.goodsSpecsIds.split(',');
            this.historySelectedSpecName = this.orderProductInfo.goodsSpecsName;
            this.historySelectedSpecId = this.orderProductInfo.goodsItemId;
            /**两种规格/一种规格，且都只有一个规格值 */
            if((goodsSpecsList.length==2||goodsSpecsList.length==1)&&res.getGoodsItemsList.length==1){
                this.noCancel = true;
                this.specsSelectedList.forEach(v=>{
                    this.historySelectedList.push(v);
                })
            }else{
                this.noCancel = false;
                let goodsSpecsIdArr= this.orderProductInfo.goodsSpecsId.split(",");
                // console.log('goodsSpecsIdArr',goodsSpecsIdArr,this.specsSelectedList);
                
                this.specsSelectedList.forEach((v,index)=>{
                    this.historySelectedList.push({
                        ...v,
                        childList:index==0?v.childList.filter(j=>j.id==goodsSpecsIdArr[0]):v.childList.filter(j=>j.id==goodsSpecsIdArr[1])
                    });
                })
            }
            
        }
    }

    /**提示弹窗 */
    async tipConfirm(){
       
       this.tipShow = false;
   }
   tipCancel(){
       this.tipShow = false;
   }
   /**判断是否商品是否可以选中 */
   getProductStatus(item){
        let str = "";
        /**无码商品和已完全退货商品不可选中 */
           if(!item.goodsSpecsName||item.returnedNum==item.num||item.isDelete||!item.isShelves){
            str = "isDisable";
           }else if(this.activeId==item.id){
            str = "isActive";
           } 
        return str;
   }
   /**计数器 */
   finishStep(val){
        this.num = Number(val);
        this.$nextTick(()=>{
            if(this.num>this.maxNum||this.num<1){
                this.num = 1
            }
        })
   }
   /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
   /**获取系统配置 */
   async getSetting(){
        let res = await TbSettingsPad.GetTbSettings({settingtype:2});
        this.settingContent = res.settingContent;
        this.isZeroStock = res.settingContent.isZeroStock;
    }
    async getInitGGListU(ids){
        // console.log('ids',ids);
        let res = await TbGoodsSpecs.GetTbGoodsSpecsList();
        let arr= ids.split(',');
        let selectArr=res.filter(v=>arr.findIndex(j=>j==v.id)>-1);
        selectArr = selectArr.map(v=>{
            return {
                ...v,
                index:arr.findIndex(j=>j==v.id)
            }
        })
        /**按照specid排序，不然对不上 */
        selectArr.sort((a,b)=>a.index-b.index);
        this.specsSelectedList = selectArr.map((v,index)=>{
            return{
                id:v.id,
                name:v.name,
                childList: index==0? v.specsItemsJson.filter(j=>this.activeInfo.itemSpecsIds1.split(',').findIndex(fi=>fi==j.id)>-1).map(jj=>{
                    return {
                        ...jj,
                        parentId:v.id
                    }
                }):
                v.specsItemsJson.filter(j=>this.activeInfo.itemSpecsIds2.split(',').findIndex(fi=>fi==j.id)>-1).map(jj=>{
                    return {
                        ...jj,
                        parentId:v.id
                    }
                })
                

            }
        })
        // console.log('specsSelectedList',this.specsSelectedList);
        
        
        
    }
    /**查询规格状态 */
    getGGActive(item,v){
        let str = "";

        if(this.selectedList.length>0&&this.specsSelectedList.length==2){
            
            let otherArr = this.selectedList.filter(j=>j.id!=item.id); 
            if(otherArr.length>0){
               
                let otherName = otherArr[0].childList[0].name;
                let otherIndex = this.specsSelectedList.findIndex(v=>v.id== otherArr[0].id); 
                let pName = otherIndex==0?otherName+'/'+v.name:v.name+'/'+otherName;
                if(this.activeInfo.getGoodsItemsList.findIndex(j=>j.goodsSpecsName==pName)==-1){
                        str = 'isDisable'
                        return str;
                    }
            }

        }

        let index = this.historySelectedList.findIndex(j=>j.id==item.id)
        let index2 = this.selectedList.findIndex(j=>j.id==item.id)
        if(index>-1){
            if(this.historySelectedList[index].childList.some(j=>j.id==v.id)){
                str = "historyActive"
            }
        }
        if(index2>-1){
            if(this.selectedList[index2].childList.some(j=>j.id==v.id)){
                str = "isActive"
            }
        }
        return str;
    }
    /**判断是否支持负库存以及当前库存是否大于0 */
    get chargeStock(){
        let val = false;
        if(this.num==this.maxNum){
            val = true;
        }
        return val;
    }
    /**选择规格 */
    async chooseSpec(item,v){
        if(this.getGGActive(item,v)=='isDisable') return;
        if(this.noCancel) return;
        let index = this.selectedList.findIndex(j=>j.id==item.id);
        if(index>-1){
            let chidIndex = this.selectedList[index].childList.findIndex(j=>j.id==v.id);
            if(chidIndex>-1){
                this.selectedList.splice(index,1);
                
            }else{
                this.selectedList[index].childList.splice(chidIndex,1);
                this.selectedList[index].childList.push({
                    id:v.id,
                    name:v.name,
                    parentId:item.id
                })
            }
        }else{
            this.selectedList.push({
                id:item.id,
                name:item.name,
                childList:[{
                    id:v.id,
                    name:v.name,
                    parentId:item.id
                }]
            })
        }
        if(this.selectedList.length==this.specsSelectedList.length){
            await this.getSpecStock();
        }
        
    }
    /**确定收货 */
    chargeFun(){
        if(!(this.selectedList.length>0&&this.selectedList.length==this.specsSelectedList.length&&this.num>0&&(!this.isZeroStock&&this.nowStock>=0||this.isZeroStock)&&this.historySelectedSpecId!=this.selectedSpecId)) return;
        this.exchangeForm = {
            goodsImgUrl:this.activeInfo.goodsImgUrl,
            name:this.activeInfo.name,
            articleNo:this.activeInfo.articleNo,
            goodsSpecsName:this.selectedSpecName,
            num:this.num,
            oldGoodsSpecsName:this.orderProductInfo.goodsSpecsName,
        }
        this.exchangeShow = true;
        
    }
    exchangeClose(){
        this.exchangeShow = false;
    }
    async confirmExchange(){
        let res = await TbExChangeGoods.PostExChangeGoods({
            shopId:this.userInfo.shopId,
            goodId:this.activeInfo.id,
            goodsItemId:this.selectedSpecId,
            oldGoodsItemId:this.historySelectedSpecId,
            orderId:this.id,
            num:this.num
        })
        this.exchangeShow = false;
        Toast("换货成功");
        location.reload();
    }
    /**计算商品总额 */
    getSellingPriceTotal(item){
        let val = 0;
        val = calculate.multiplication(item.num,item.sellingPrice);
        return val;
    }
    /**计数器样式 */
    chargeHis(){
        let str = "";
        let name1= [];
        let name2= [];
        let nameStr1,nameStr2 = "";
        this.historySelectedList.forEach(v=>{
            v.childList.forEach(j=>{
                name1.push(j.name)
            })
        })
        this.selectedList.forEach(v=>{
            v.childList.forEach(j=>{
                name2.push(j.name)
            })
        })
        nameStr1 = name1.join(",");
        nameStr2 = name2.join(",");
        if(nameStr1!=nameStr2&&this.selectedList.length==this.specsSelectedList.length){
            str="pnbON"
        }
        return str;
    }
    async printTest(){
        if(this.isPrintLoading) return;
        let address = localStorage.getItem('padShopInfo')?JSON.parse(localStorage.getItem('padShopInfo')).address:''
        this.isPrintLoading = true;
        let shopInfo = await TbShop.GetTbShopById({id:this.userInfo['shopId']});
        let resShop = await TbShop.GetInitShopInfo({shopid:shopInfo.id});
        let isnewReceipt = resShop.webShopReceiptTemplateType; 
        if(isnewReceipt==0){
            let resSetting= await TbSettingsPad.GetTbSettings({
            settingtype: 5,
            });
            let form = Object.assign({},{settingContent:resSetting.settingContent},{orderInfo:Object.assign({},this.form,{address:address})},{type:'receipt'})
            console.log('form',form);
            let time = 3000*resSetting.settingContent.putNum;
            if(form.settingContent.putNum>0){
                for(let i =1;i<=form.settingContent.putNum;i++){
                    setTimeout(()=>{
                        const canvas = this.$refs['barcodeCanvas'];
                      JsBarcode('canvas', form.orderInfo.orderNo, {
                        format: "CODE128", // 可以选择不同的格式，例如 CODE128, CODE39 等
                        lineColor: "#000",
                        width: 3,
                        height: 100,
                        displayValue: false
                      });
                      let barcodeImage = canvas.toDataURL("image/png"); // 转换为Base64编码的PNG图像
                        PrintEvent1(form,barcodeImage)
                    },3000)
                }
            }
            setTimeout(()=>{
            this.isPrintLoading = false;
            },time)
        }else{
            let res = await TbShopReceiptTemplate.GetTbShopReceiptTemplate({
            shopNo:shopInfo.shopNo,
            shopId:shopInfo.id
        })
        let padSetInfo= res;
        let form = Object.assign({},{settingContent:padSetInfo},{orderInfo:Object.assign({},this.form,{address:address})},{type:'receipt'});
        let putNum = res.contentJson.receiptTemplateMore.printNum?res.contentJson.receiptTemplateMore.printNum:1;
        let time = 3000*putNum;
        setTimeout(()=>{
            const canvas = this.$refs['barcodeCanvas'];
            JsBarcode('canvas', form.orderInfo.orderNo, {
                format: "CODE128", // 可以选择不同的格式，例如 CODE128, CODE39 等
                lineColor: "#000",
                width: 3,
                height: 100,
                displayValue: false
            });
            let barcodeImage = canvas.toDataURL("image/png"); // 转换为Base64编码的PNG图像
            PrintEvent3(form,barcodeImage,putNum)
        },3000)
      
        setTimeout(()=>{
            this.isPrintLoading = false;
        },time)
        }

    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/changeOrderDetail.vue